<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="跟单员用户id"
                clearable
                v-model="followerUserId"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input
                placeholder="交易员用户id"
                clearable
                v-model="leaderUserId"
                size="mini"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="symbolId"
                placeholder="交易对"
                clearable
                size="mini"
              >
                <el-option
                  v-for="item in symbolList"
                  :key="item.symbol"
                  :label="item.symbol.toLocaleUpperCase()"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <el-button size="mini" @click="clearFiled">重置</el-button>
          </div>
          <div class="item">
            <el-button
              size="mini"
              type="primary"
              @click="handleSearch({ page: 1 })"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="500">
        <el-table-column label="交易对" prop="symbol" align="center" />
        <el-table-column
          label="跟单员用户id"
          prop="followerUserId"
          align="center"
        />
        <el-table-column
          label="交易员用户id"
          prop="leaderUserId"
          align="center"
        />
        <el-table-column
          prop="followerDivideU"
          label="跟单分润(折U)"
          align="center"
        />
        <el-table-column
          prop="followerMarginU"
          label="跟随本金(折U)"
          align="center"
        />

        <el-table-column
          label="跟随收益(折U)"
          prop="followerProfitU"
          align="center"
        />
        <el-table-column
          label="跟随总额(成交额)(U)"
          prop="followerTrade"
          align="center"
        />

        <el-table-column label="亏损笔数" prop="lossCount" align="center" />
        <el-table-column label="赢利笔数" prop="profitCount" align="center" />

        <el-table-column label="更新时间" width="160" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.updatedTime | moment }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </pagination>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      symbolId: "",
      leaderUserId: "",
      followerUserId: "",
      tabList: [],
      totalCount: 0,
      symbolId: "",
      symbolList: [],
      pagination: {
        page: 1,
        size: 25,
      },
    };
  },
  computed: {},
  mounted() {
    api.getSymbolList({ type: "CONTRACT" }).then((res) => {
      if (res.code == 0) {
        this.symbolList = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    clearFiled() {
      this.followerUserId = "";
      this.leaderUserId = "";
      this.symbolId = "";
      this.handleSearch({ page: 1 });
    },
    handleSearch(data = {}) {
      api
        .copytradeFollowerStat({
          symbolId: this.symbolId,
          followerUserId: this.followerUserId,
          leaderUserId: this.leaderUserId,
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { total, items } = res.data;
            this.tabList = items;
            this.totalCount = total;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
<style scoped lang="less">
.avatar {
  width: 50px;
  height: 50px;
}
</style>
